import Image from 'next/image'
import Typography from '@Components/typo'

interface CardWithTextProps {
  title: string
  subTitle: string
  imagePath: string
  isSeperate?: boolean
}

const CardWithText = ({
  title,
  subTitle,
  imagePath,
  isSeperate,
}: CardWithTextProps) => {
  return (
    <div className='relative'>
      <div className='absolute z-30 flex h-[392px] flex-col justify-end p-4'>
        <Typography weight='bold' className='text-white'>
          {title}
        </Typography>
        <div className='text-white'>{subTitle}</div>
      </div>
      <div
        className={`absolute bottom-0 z-20 w-full rounded-b-2xl bg-gradient-to-b from-[#26226200] to-[#262262] ${
          isSeperate ? 'h-[139px]' : 'h-[107px]'
        }`}
      />
      <Image
        src={imagePath}
        alt=''
        width={100}
        height={100}
        className='relative h-[392px] w-full rounded-2xl object-cover'
      />
    </div>
  )
}

export default CardWithText
